import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.13.2_typescript@5.6.3_vite@5.4.10/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.13.2_typescript@5.6.3_vite@5.4.10/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}